export const LIVE_CHART_SOURCE_FACTORY = Symbol('live-chart-source-factory');
